export class ProfileMenuItem {
  svgIcon?: string;
  icon?: string;
  title: string = '';
  action: any;
  orderRank?: number;
}
